import { Injectable } from '@angular/core';
import { FormAction } from '../form.constants';
import { FormActionHandlerService } from './action-handlers/base.service';
import { CloseFormActionHandlerService } from './action-handlers/close.service';
import { NoSignFormActionHandlerService } from './action-handlers/no-sign.service';
import { PrintFormActionHandlerService } from './action-handlers/print.service';
import { RequestPaymentFormActionHandlerService } from './action-handlers/request-payment.service';
import { RequestSignatureFormActionHandlerService } from './action-handlers/request-signature.service';
import { SaveFormActionHandlerService } from './action-handlers/save.service';
import { SignFormActionHandlerService } from './action-handlers/sign.service';
import { SubmitFormActionHandlerService } from './action-handlers/submit.service';
import { SubmitCostReportActionHandlerService } from './action-handlers/submit-cost-report.service';
import { UnlockFormActionHandlerService } from './action-handlers/unlock.service';
import { CompleteReviewFormActionHandlerService } from './action-handlers/complete-review.service';
import { SaveCreditsFormActionHandlerService } from './action-handlers/save-credits.service';
import { CompleteAuditActionHandlerService } from './action-handlers/complete-audit.service';
import { CreateInitialCertLetterService } from './action-handlers/create-initial-cert-letter.service';
import { CreateFinalCertAttestationService } from './action-handlers/create-final-cert-attestation.service';
import { CreateFinalCertLetterService } from './action-handlers/create-final-cert-letter.service';
import { ResendInitialCertLetterService } from './action-handlers/resend-initial-cert-letter.service';
import { AddENTIdActionHandlerService } from './action-handlers/add-ent-id.service';
import { SetReceivedActionHandlerService } from './action-handlers/set-received.service';
import { PayFormActionHandlerService } from './action-handlers/pay.service';
import {SendIrrevocableDesigneeAgreementActionHandlerService} from './action-handlers/send-irrevocable-designee-agreement.service';
import { SendDeskAuditActionHandlerService } from './action-handlers/send-desk-audit.service';
import {
  ManagerReviewCompleteActionHandlerService,
  AssistantDirectorReviewCompleteActionHandlerService,
  DirectorReviewCompleteActionHandlerService
} from './action-handlers/rd-review-stage.service';
import { RdReturnToManagerActionHandlerService } from './action-handlers/rd-return-to-manager.service';
import { SendCertificationActionHandlerService } from './action-handlers/send-certification.service';

@Injectable()
export class FormActionHandlerAuthorityService {
  constructor(
    private addENTId: AddENTIdActionHandlerService,
    private closeAct: CloseFormActionHandlerService,
    private noSignAct: NoSignFormActionHandlerService,
    private payAct: PayFormActionHandlerService,
    private printAct: PrintFormActionHandlerService,
    private reqPayAct: RequestPaymentFormActionHandlerService,
    private setReceived: SetReceivedActionHandlerService,
    private sendIrrevocableDesigneeAgreement: SendIrrevocableDesigneeAgreementActionHandlerService,
    private reqSigAct: RequestSignatureFormActionHandlerService,
    private saveAct: SaveFormActionHandlerService,
    private saveCreditsAct: SaveCreditsFormActionHandlerService,
    private signAct: SignFormActionHandlerService,
    private submitAct: SubmitFormActionHandlerService,
    private completeReviewAct: CompleteReviewFormActionHandlerService,
    private unlockAct: UnlockFormActionHandlerService,
    private submitCostReportAct: SubmitCostReportActionHandlerService,
    private completeAuditAct: CompleteAuditActionHandlerService,
    private createInitialCertLetter: CreateInitialCertLetterService,
    private resendInitialCertLetter: ResendInitialCertLetterService,
    private createFinalCertAttestation: CreateFinalCertAttestationService,
    private createFinalCertLetter: CreateFinalCertLetterService,
    private sendDeskAudit: SendDeskAuditActionHandlerService,
    private managerReviewComplete: ManagerReviewCompleteActionHandlerService,
    private assistantDirectorReviewComplete: AssistantDirectorReviewCompleteActionHandlerService,
    private directorReviewComplete: DirectorReviewCompleteActionHandlerService,
    private rdReturnToManager: RdReturnToManagerActionHandlerService,
    private sendCertification: SendCertificationActionHandlerService
  ) {}

  getHandler(action: FormAction): FormActionHandlerService {
    switch (action) {
      case 'addENTId':
        return this.addENTId;
      case 'close':
        return this.closeAct;
      case 'no-sign':
        return this.noSignAct;
      case 'pay':
        return this.payAct;
      case 'print':
        return this.printAct;
      case 'set-received':
        return this.setReceived;
      case 'sendIrrevocableDesigneeAgreement':
        return this.sendIrrevocableDesigneeAgreement;
      case 'request-payment':
        return this.reqPayAct;
      case 'request-signature':
        return this.reqSigAct;
      case 'save':
        return this.saveAct;
      case 'save-credits':
        return this.saveCreditsAct;
      case 'sign':
        return this.signAct;
      case 'submit':
        return this.submitAct;
      case 'submitCostReport':
        return this.submitCostReportAct;
      case 'complete-review':
        return this.completeReviewAct;
      case 'unlock':
        return this.unlockAct;
      case 'completeAudit':
        return this.completeAuditAct;
      case 'createInitialCertLetter':
        return this.createInitialCertLetter;
      case 'resendInitialCertLetter':
        return this.resendInitialCertLetter;
      case 'createFinalCertLetter':
        return this.createFinalCertLetter;
      case 'createFinalCertAttestation':
        return this.createFinalCertAttestation;
      case 'send-desk-audit':
        return this.sendDeskAudit;
      case 'manager-review-complete':
        return this.managerReviewComplete;
      case 'assistant-director-review-complete':
        return this.assistantDirectorReviewComplete;
      case 'director-review-complete':
        return this.directorReviewComplete;
      case 'rd-return-to-manager':
        return this.rdReturnToManager;
      case 'send-certification':
        return this.sendCertification;
    }
  }
}
